/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Not_Found_1Inputs */

const en_listing_not_found_1 = /** @type {(inputs: Listing_Not_Found_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing not found.`)
};

const es_listing_not_found_1 = /** @type {(inputs: Listing_Not_Found_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuncio no encontrado.`)
};

const fr_listing_not_found_1 = /** @type {(inputs: Listing_Not_Found_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annonce introuvable.`)
};

const de_listing_not_found_1 = /** @type {(inputs: Listing_Not_Found_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserat nicht gefunden.`)
};

const ja_listing_not_found_1 = /** @type {(inputs: Listing_Not_Found_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品が見つかりません。`)
};

const zh_listing_not_found_1 = /** @type {(inputs: Listing_Not_Found_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到商品。`)
};

const ar_listing_not_found_1 = /** @type {(inputs: Listing_Not_Found_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإعلان غير موجود.`)
};

const id_listing_not_found_1 = /** @type {(inputs: Listing_Not_Found_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing tidak ditemukan.`)
};

const it_listing_not_found_1 = /** @type {(inputs: Listing_Not_Found_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuncio non trovato.`)
};

const ru_listing_not_found_1 = /** @type {(inputs: Listing_Not_Found_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объявление не найдено.`)
};

const pt_listing_not_found_1 = /** @type {(inputs: Listing_Not_Found_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anúncio não encontrado.`)
};

const ko_listing_not_found_1 = /** @type {(inputs: Listing_Not_Found_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품을 찾을 수 없습니다.`)
};

/**
* | output |
* | --- |
* | "Listing not found." |
*
* @param {Listing_Not_Found_1Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_not_found_1 = /** @type {((inputs?: Listing_Not_Found_1Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Not_Found_1Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_not_found_1(inputs)
	if (locale === "es") return es_listing_not_found_1(inputs)
	if (locale === "fr") return fr_listing_not_found_1(inputs)
	if (locale === "de") return de_listing_not_found_1(inputs)
	if (locale === "ja") return ja_listing_not_found_1(inputs)
	if (locale === "zh") return zh_listing_not_found_1(inputs)
	if (locale === "ar") return ar_listing_not_found_1(inputs)
	if (locale === "id") return id_listing_not_found_1(inputs)
	if (locale === "it") return it_listing_not_found_1(inputs)
	if (locale === "ru") return ru_listing_not_found_1(inputs)
	if (locale === "pt") return pt_listing_not_found_1(inputs)
	return ko_listing_not_found_1(inputs)
});